<template>
    <v-app>
        <customer-type-setup
        :dialog="customerTypeDialog"
        :data="data"
        @update:dialog="customerTypeDialog = $event"
        />
        <v-container fluid>
            <template v-if="$insertAccess($route.fullPath)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                    <v-expansion-panel-title
                                        color="blue-grey-lighten-4"
                                        class="panel-header"
                                        ><span>{{
                                        isEntryMode ? "Add Customer Information" : "Update Customer Information"
                                        }}</span></v-expansion-panel-title
                                    >
                                    <v-expansion-panel-text>
                                        <v-row class="py-2 no-gutters justify-space-around">
                                            <v-col lg="4" md="4" cols="12">
                                                <v-autocomplete
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="customer_type_id.value.value"
                                                    :error-messages="customer_type_id.errorMessage.value"
                                                    clearable
                                                    :items="getCustomerTypeList"
                                                    :item-title="(item) => `${item.code} - ${item.name}`"
                                                    autocomplete="off"
                                                    item-value="id"
                                                    @update:modelValue="getCustomerTypeList"
                                                 >
                                                    <template #label>
                                                        Company Type
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                    <template v-slot:append-inner>
                                                        <v-slide-x-reverse-transition mode="out-in">
                                                        <v-icon
                                                            @mousedown.stop="openAddCustomerType"
                                                            icon="mdi-plus-circle-outline"
                                                            color="primary"
                                                            size="24"
                                                            class="cursor-pointer"
                                                        ></v-icon>
                                                        </v-slide-x-reverse-transition>
                                                    </template>
                                                </v-autocomplete>

                                                <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="customer_name.value.value"
                                                :error-messages="customer_name.errorMessage.value"
                                                clearable
                                                >
                                            <template #label>
                                                        Customer Name
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                            </v-text-field>

                                                <v-text-field
                                                label="Shop Name"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="customer_owner_name.value.value"
                                                :error-messages="customer_owner_name.errorMessage.value"
                                                clearable
                                                >
                                                </v-text-field>

                                                <v-text-field
                                                label="Email Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="customer_email.value.value"
                                                :error-messages="customer_email.errorMessage.value"
                                                clearable
                                                >
                                                </v-text-field>

                                            </v-col>

                                            <v-col lg="4" md="4" cols="12">
                                                <v-autocomplete
                                                    label="Customer Country"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="customer_country_id.value.value"
                                                    :items="getInvCountryList"
                                                    item-title="name"
                                                    item-value="id"
                                                    :error-messages="customer_country_id.errorMessage.value"
                                                    :menu-props="{ width: 300 }"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    
                                                    <template v-slot:selection="{ props, item }">
                                                        <div class="d-flex align-center noto-color-emoji-regular"
                                                            v-bind="props"
                                                            color="primary"
                                                            variant="tonal"
                                                        >
                                                        <span class="mr-1">{{ item.raw.emoji }}</span>
                                                        {{ item.raw.name }}
                                                        </div>
                                                    </template>
                                                    <template v-slot:item="{ props, item }">
                                                        <v-list-item v-bind="props" v-slot="" :title="null">
                                                            <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                                <span class="mr-2 text-lg">{{ item.raw.emoji }}</span>
                                                                <div class="flex-grow-1">
                                                                    <span>{{ item.raw.name }}</span>
                                                                    <small v-if="item.raw.native" class="text-grey">
                                                                        ({{ item.raw.native }})
                                                                    </small>
                                                                </div>
                                                                <div class="text-grey text-caption">
                                                                    +{{ item.raw.phonecode }}
                                                                </div>
                                                            </div>
                                                        </v-list-item>
                                                    </template>
                                                    <template #label>
                                                        Customer Country
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>                                                    
                                                </v-autocomplete>
                                               
                                                <v-text-field
                                                label="Customer Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="customer_address.value.value"
                                                :error-messages="customer_address.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-text-field
                                                label="VAT Number"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="customer_vat.value.value"
                                                :error-messages="customer_vat.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-text-field
                                                    label="Mobile Number"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="customer_mobile.value.value"
                                                    :error-messages="customer_mobile.errorMessage.value"
                                                    clearable
                                                >
                                                </v-text-field>
                                            </v-col>

                                            <v-col lg="4" md="4" cols="12">
                                               
                                                <v-text-field
                                                label="BIN No."
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="customer_bin.value.value"
                                                :error-messages="customer_bin.errorMessage.value"
                                                clearable
                                                >
                                                </v-text-field>

                                                <v-text-field
                                                label="TIN No."
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="customer_tin.value.value"
                                                :error-messages="customer_tin.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-text-field
                                                    label="Customer Website"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="customer_website.value.value"
                                                    :error-messages="customer_website.errorMessage.value"
                                                    clearable
                                                ></v-text-field>

                                                <v-text-field
                                                    label="Customer Nature of Business"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="customer_business_nature.value.value"
                                                    :error-messages="customer_business_nature.errorMessage.value"
                                                    clearable
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea
                                                clear-icon="mdi-close-circle"
                                                rows="2"
                                                maxlength="500"
                                                label="Description"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="description.value.value"
                                                :error-messages="description.errorMessage.value"
                                                clearable
                                                ></v-textarea>
                                            </v-col>
                    
                                            <v-col>
                                                <v-row>
                                                    <v-col cols="9" class="px-2">
                                                        <v-file-input
                                                            v-model="selectedImage"
                                                            label="Customer Image"
                                                            accept="image/*"
                                                            density="compact"
                                                            single-line
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            show-size
                                                            @input="previewImage"
                                                            @click:clear="clearImage"
                                                            class="ellipsis-filename"
                                                            persistent-hint
                                                            hint="Image must be exactly 120px × 120px"
                                                            prepend-icon="mdi-camera"
                                                            title="image"
                                                        >
                                                        </v-file-input>
                                                    </v-col>
                                                    <v-col cols="3" class="px-2">
                                                        <div class="px-2">
                                                            <v-img :src="preview" cover class="preview-image"></v-img>
                                                        </div>
                                                    </v-col>
                                                    
                                                    <!-- <v-col cols="2" class="px-2">
                                                        <v-checkbox label="Active" v-model="status.value.value" :true-value="1" :false-value="0" />
                                                        <input v-model="customer_id.value.value" type="hidden" />
                                                     </v-col> -->
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>
import customerTypeSetup from "@/components/module/inventory/customerManagement/customerTypeSetup.vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRoute, useRouter } from "vue-router";
import { fileServerUrl } from "@/store/api";
import { reactive } from "vue";

const DEFAULT_IMAGE = "/src/assets/no_preview.jpeg";

export default {
    components: {
        customerTypeSetup,
    },
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        contactPersonInfo: [0],
        bankInfo: [0],
        loading: false,
        search: "",
        dialog: false,
        customerTypeDialog: false,
        isEntryMode: true,
        unitDialog: false,
        data: {},
        preview: "/src/assets/no_preview.jpeg",
        headers: [
        { title: "#SL", align: "center",key: "index",width: "7%",sortable: false},
        { title: "Code", key: "user_code", align: "left", sortable: false },
        { title: "Name", key: "name", align: "left", sortable: false },
        { title: "Mobile", align: "left", key: "mobile", sortable: true },
        { title: "Email", align: "left", key: "email", sortable: true },
        { title: "Status", align: "center", key: "status", sortable: true },
        { title: "Actions", align: "center", key: "actions", sortable: false },
        ],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getCustomerTypeList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getCustomerTypeList").then((response) => {
            this.loading = false;
            });
        }
        if (this.$store.getters.getInvCountryList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getInvCountryList").then((response) => {
            this.loading = false;
            });
        }
    },
    computed: {
        getInvCountryList() {
            let country = this.$store.getters.getInvCountryList;
            if (country.length > 0) {
                return country;
            }
        },

        getCustomerTypeList() {
            let data = this.$store.getters.getCustomerTypeList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },

        editingCustomer() {
            return this.$store.getters.getEditingCustomer;
        },
    },
    methods: {
        openAddCustomerType() {
            this.data = {
                id: "",
                name: "",
                code: "",
                remarks: "",
                status: 1,
            };
            this.customerTypeDialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.customerTypeDialog = false;
            this.data = {};
        },
        resetForm() {
            this.data = {};
            this.preview = "/src/assets/no_preview.jpeg";
            this.selectedImage = null;
            this.files = [];
        },
        previewImage: function (event) {
            this.selectedImage = event.target.files[0];
            const input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = (e) => {
                this.preview = e.target.result;
                };
                this.image = input.files[0];
                reader.readAsDataURL(input.files[0]);
            } else {
                this.preview = "/src/assets/no_preview.jpeg";
            }
            },
            clearImage() {
            this.preview = "/src/assets/no_preview.jpeg";
        },
    },

    setup() {
        const { handleSubmit, resetForm } = useForm({
        validationSchema: yup.object({
                customer_type_id: yup.number().positive().integer().required().label("Customer Type Name"),
                customer_name: yup.string().min(1).max(50).required().trim().label("Customer Name"),
                customer_country_id: yup.number().positive().integer().required().label("Customer Country"),
                customer_email: yup.string().nullable().trim().email("Must be a valid email").max(50),
                customer_website: yup.string().nullable().trim().url("Must be a valid URL").max(50),
            }),
        });

        const customer_type_id = useField("customer_type_id");
        const customer_owner_name = useField("customer_owner_name");
        const customer_email = useField("customer_email");
        const customer_name = useField("customer_name");
        const customer_country_id = useField("customer_country_id");
        const customer_mobile = useField("customer_mobile");
        const customer_vat = useField("customer_vat");
        const customer_bin = useField("customer_bin");
        const customer_address = useField("customer_address");
        const customer_website = useField("customer_website");
        const customer_tin = useField("customer_tin");
        const customer_business_nature = useField("customer_business_nature");
        const description = useField("description");
        const status = useField("status");
        const customer_id = useField("customer_id");
        

        const contacts = ref(
        [
            {
                name: "",
                mobile: "",
                email: "",
                designation: "",
                department: "",
            },
        ]);

        const bank_info = ref(
        [
            {
                bank_name: "",
                account_holder_name: "",
                ac_number: "",
                branch_name: "",
                routing_number: "",
                swift_code: "",
                ifsc_number: "",
            },
        ]);

        const contactErrors = reactive({});
        const errorMessages = ref("");
        const loading = ref("");
        const selectedImage = ref(null);
        const files = ref([]);
        const preview = ref(DEFAULT_IMAGE);

        const isEntryMode = ref(true);

        const store = useStore();
        const router = useRouter();
        const route = useRoute();

        const redirectPath = ref({ path: '/inventory/customer-list' });
        const pathArray = route.fullPath.split('/');
        if (pathArray.includes('sales')) redirectPath.value = { path: '/sales/customer-record' };
        else if(pathArray.includes('inventory')) redirectPath.value = { path: '/inventory/customer-list' };

        const addContactRow = () => {
            contacts.value.push({
                name: "",
                mobile: "",
                email: "",
                designation: "",
                department: "",
            });
        };

        const removeContactRow = (index) => {
        if (contacts.value.length > 1) {
            contacts.value.splice(index, 1);
            delete contactErrors[index];
            const newErrors = {};
            Object.keys(contactErrors).forEach((key) => {
                const idx = parseInt(key);
                if (idx > index) {
                    newErrors[idx - 1] = contactErrors[key];
                } else if (idx < index) {
                    newErrors[idx] = contactErrors[key];
                }
            });
            Object.keys(contactErrors).forEach((key) => delete contactErrors[key]);
            Object.assign(contactErrors, newErrors);
        }
        };

        const addBankInfo = () =>
        ref(
            bank_info.value.push({
            bank_name: "",
            account_holder_name: "",
            ac_number: "",
            branch_name: "",
            routing_number: "",
            swift_code: "",
            ifsc_number: "",
            })
        );

        const removeBankInfoRow = (index) => {
        if (bank_info.value.length > 1) {
            bank_info.value.splice(index, 1);
        }
        };

        const submit = handleSubmit((values) => {

            values.status = 1

            const contactsData = contacts.value || [];
            const bankInfoData = bank_info.value || [];

            const formData = new FormData();

            Object.keys(values).forEach((key) => {
            if (values[key] === undefined) values[key] = null;
                formData.append(key, values[key]);
            });

            // formData.append("contacts",  JSON.stringify(contactsData));
            // formData.append("bank_info", JSON.stringify(bankInfoData));

            if (selectedImage.value) {
                formData.append("image", selectedImage.value);
            }

            if (files.value) {
                formData.append("files", files.value);
            }

            store.dispatch("saveUpdateCustomer", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                resetForm();
                loading.value = false;
                toast.success(response.data.message, {
                  timeout: 3000,
                });
                setTimeout(() => {
                    router.push(redirectPath.value);
                }, 1000);
                
            })
            .catch((error) => {
                loading.value = false;
                if (error.response && error.response.data) {
                    const { message, errors } = error.response.data;
                    if (errors) {
                        const errorMessages = Object.values(errors).flat() .join('\n');
                        toast.error(`${message}\n${errorMessages}`);
                    } else {
                        toast.error(message || 'Something went wrong.');
                    }
                } else {
                    toast.error('Server error. Please try again.');
                }
                // toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            customer_type_id,
            customer_owner_name,
            customer_email,
            customer_name,
            customer_mobile,
            customer_address,
            customer_website,
            customer_vat,
            customer_country_id,
            customer_tin,
            customer_bin,
            customer_business_nature,
            description,
            contacts,
            bank_info,
            status,
            addContactRow,
            removeContactRow,
            contactErrors,
            addBankInfo,
            removeBankInfoRow,
            errorMessages,
            selectedImage,
            files,
            preview,
            isEntryMode,
            customer_id,
            resetForm,
            loading,
        };
    },
    mounted() {
        console.log(this.$store.getters.getEditingCustomer);
        if (this.$store.getters.getEditingCustomer) {
            this.isEntryMode = false;
            const customer = this.$store.getters.getEditingCustomer;
            this.customer_id.value.value = customer.customer_id;
            this.customer_owner_name.value.value = customer.customer.customer_owner_name;
            this.customer_email.value.value = customer.customer.customer_email;
            this.customer_name.value.value = customer.customer.customer_name;
            this.customer_mobile.value.value = customer.customer.customer_mobile;
            this.customer_vat.value.value = customer.customer.customer_vat;
            this.customer_bin.value.value = customer.customer.customer_bin;
            this.customer_tin.value.value = customer.customer.customer_tin;
            this.customer_business_nature.value.value = customer.customer.customer_business_nature;
            this.customer_address.value.value = customer.customer.customer_address;
            this.customer_website.value.value = customer.customer.customer_website;
            this.customer_type_id.value.value = customer.customer.customer_type_id;
            this.customer_country_id.value.value = customer.customer.customer_country_id;
            this.description.value.value = customer.customer.description;
            this.status.value.value = customer.customer.status;  
            this.contacts = customer.contacts || [
            {
                name: "",
                mobile: "",
                email: "",
                designation: "",
                department: "",
            },
        ];
        this.bank_info = customer.bank_info || [
            {
                bank_name: "",
                account_holder_name: "",
                ac_number: "",
                branch_name: "",
                routing_number: "",
                swift_code: "",
                ifsc_number: "",
            },
        ];
        // this.status.value.value = customer.status == 1 ? true : false;
        if (customer.image) {
            this.preview = customer.image
            ? fileServerUrl + customer.image
            : "/src/assets/no_preview.png";
        } else {
            this.preview = DEFAULT_IMAGE;
        }
        } else {
            this.customer_id.value.value = "";
            this.isEntryMode = true;
        }
    },

    beforeUnmount() {
        // Clear the editing customer from Vuex when component is destroyed
        this.$store.commit('clearEditingCustomer');
      }
};
</script>
